import take from '../take';

export default function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_dropLast.js
// module id = 7j3/
// module chunks = 22